export const getYearGapLayout = (bannerBottom, sliderTop) => ({
  top: (bannerBottom + sliderTop) / 2,
  availableHeight: Math.max(0, sliderTop - bannerBottom),
});

export const getYearFontSize = ({ guess, availableHeight, viewportWidth }) => {
  const isBce = guess < 0;
  const preferredSize = isBce ? 80 : 192;
  const widthLimit = viewportWidth * (isBce ? 0.18 : 0.3);
  const gapLimit = availableHeight * (isBce ? 0.56 : 0.62);
  const minimumSize = availableHeight < 32
    ? Math.max(16, availableHeight * 0.72)
    : 24;

  return Math.max(minimumSize, Math.min(preferredSize, widthLimit, gapLimit));
};
